import { useDeleteLogicoUsuario } from "@/hooks/useDeleteLogicoUsuario";
import type { Aprendiz } from "@/interfaces/user.interface";
import { AccionesGenericas } from "./AccionesGenericas";
import { EditAprendizForm } from "../forms/aprendices/EditAprendizForm";
import { DetalleAprendiz } from "../dashboards/superAdmin/modales/ModalDetalleAprendiz";

type AccionesAprendizCellProps = {
  aprendiz: Aprendiz;
  queryKey: ReadonlyArray<unknown>;
};

export default function AccionesAprendizCell({
  aprendiz,
  queryKey,
}: AccionesAprendizCellProps) {
  const { mutate } = useDeleteLogicoUsuario({
    queryKey: queryKey,
  });

  return (
    <AccionesGenericas
      data={aprendiz}
      id={aprendiz.idUsuario}
      label="Aprendiz"
      queryKey={queryKey}
      FormularioEdicion={EditAprendizForm}
      onDelete={(id) => mutate(id)}
      DetalleContenido={DetalleAprendiz}
    />
  );
}
